import React from 'react';
import { View, Text, ViewStyle, TouchableWithoutFeedback } from 'react-native';
import { styles } from './style';
import { styles as stylesFn } from '@/common/style';
import Flex from '@/component/atom/Flex';
import { Stepper } from '@/component/Stepper/Stepper';
// import { ReturnT } from '../../hooks/usePageInfo';
import { $k18n } from '@/common/i18n';
import Toast from '@/component/Toast/Toast';
import { useCountDown } from './hooks';
import { useCoudanInfoStore } from '../coudanInfoStore';
import { KText, KView } from '@/component/RtlLayout';
import ArrowIcon from '@/assets/icon/arrow_right_grey.png';
import { logger } from '@/common/log';
import { useQuery } from '@/hooks/useQuery';
import { useJumpToGoodsDetailPage } from '@/common/biz/jump';
import KwaiImage from '@kds/image';
import { KTouchableWithoutFeedback } from '@/component/RtlLayout/Touchable';
// type CartShopItem = ReturnT['cartShopList'][number];

interface IProps {
    pruductItem?: any;
    style?: ViewStyle;
    onSkuNumChange?: (num: number, type?: 0 | 1) => void;
    onGoDetail?: () => void;
    onRefresh?: () => void;
    recoItems?: any;
    handleMakeUpItems?: any;
    showDetailCoudan?: any;
}
const ProductCard = (props: IProps) => {
    const { style, pruductItem, onSkuNumChange, onGoDetail, onRefresh, recoItems, handleMakeUpItems, showDetailCoudan } = props;
    const itemId = useQuery('itemId');

    const { extraInfo, setRecoItems, setCurPopCartItem, setShowSpecPop } = useCoudanInfoStore(
        ({ extraInfo, setRecoItems, setCurPopCartItem, setShowSpecPop }) => ({
            extraInfo,
            setRecoItems,
            setCurPopCartItem,
            setShowSpecPop,
        })
    );
    const underlinePrice = pruductItem?.showPrice?.origin;

    const { jumpToGoodsDetailPage } = useJumpToGoodsDetailPage();

    function goDetail() {
        if (Number(itemId) === Number(pruductItem?.itemId)) {
            return;
        }
        logger.sendClick({
            action: 'BOUGHT_TOGETHER_PRODUCT_CARD',
            params: {
                item_id: pruductItem?.itemId,
                seckill_tag: pruductItem?.activityInfo?.activityId ? 1 : 0, // 秒杀表示
                product_discount: pruductItem?.discountRate, // 商品折扣
                product_type: pruductItem?.extra?.productType, //商品类别
                element_type: 1, // 0:商详页凑单楼层模块，1:商详页凑单半屏页
                click_area: 0, // 点击位置。0:商品卡片,1:商品卡片前方勾选按钮,2:规格选项,3:规格数量
            },
        });
        jumpToGoodsDetailPage({
            itemId: pruductItem.itemId,
            extParams: {
                cT: extraInfo?.version === 2 ? 49 : 30, // 新增
                cId: itemId,
            },
        });
    }

    const finishCountDownCB = () => {
        Toast.show(
            $k18n({
                id: 'k_370316',
                text: '部分商品信息有变更',
            })
        );
        setTimeout(() => {
            onRefresh?.();
        }, 1000);
    };

    const { flashSaleCountDownStr } = useCountDown(pruductItem, finishCountDownCB);
    // const flashSaleCountDownStr = 'A oferta relâmpago termina em 03:53:89';

    const currentSku = pruductItem?.skus?.[pruductItem?.extra?.selectSkuIndex] || pruductItem?.skus[0];
    const skuImageUrl = currentSku?.imageUrl || pruductItem?.imageUrls?.[0];

    const onSkuNumChangeV2 = (num, type) => {
        logger.sendClick({
            action: 'BOUGHT_TOGETHER_PRODUCT_CARD',
            params: {
                item_id: pruductItem?.itemId,
                seckill_tag: pruductItem?.activityInfo?.activityId ? 1 : 0, // 秒杀表示
                product_discount: pruductItem?.discountRate, // 商品折扣
                product_type: pruductItem?.extra?.productType, //商品类别
                element_type: 1, // 0:商详页凑单楼层模块，1:商详页凑单半屏页
                click_area: 3, // 点击位置。0:商品卡片,1:商品卡片前方勾选按钮,2:规格选项,3:规格数量
                click_area_plus_minus: type, // 加减符号。0:减,1:加
            },
        });
        const copyRecoItems = JSON.parse(JSON.stringify(recoItems));
        const itemIndex = copyRecoItems.findIndex(recoItem => recoItem.itemId === pruductItem.itemId);
        const skuIndex = copyRecoItems[itemIndex].skus.findIndex(sku => sku.skuId === currentSku.skuId);
        copyRecoItems[itemIndex].skus[skuIndex].skuQuantity = num;

        setRecoItems(copyRecoItems);
        const selectProducts = copyRecoItems
            .filter(i => i?.extra?.selected)
            .map(item => {
                return {
                    itemId: item.itemId,
                    skuId: item?.skus?.[item?.extra?.selectSkuIndex]?.skuId,
                    quantity: item?.skus?.[item?.extra?.selectSkuIndex]?.skuQuantity,
                };
            });
        handleMakeUpItems(selectProducts);
    };

    const onSpecClick = item => {
        logger.sendClick({
            action: 'BOUGHT_TOGETHER_PRODUCT_CARD',
            params: {
                item_id: pruductItem?.itemId,
                seckill_tag: pruductItem?.activityInfo?.activityId ? 1 : 0, // 秒杀表示
                product_discount: pruductItem?.discountRate, // 商品折扣
                product_type: pruductItem?.extra?.productType, //商品类别
                element_type: 1, // 0:商详页凑单楼层模块，1:商详页凑单半屏页
                click_area: 2, // 点击位置。0:商品卡片,1:商品卡片前方勾选按钮,2:规格选项,3:规格数量
            },
        });
        const itemNew = {
            ...item,
            skuId: item?.skus?.[item?.extra?.selectSkuIndex]?.skuId,
        };
        setCurPopCartItem(itemNew);
        console.log('setShowSpecPop>>>>>>');
        setShowSpecPop(true);
    };

    const clickSpecDesc = item => {
        if (showDetailCoudan?.if_product_addon_spec_modifiabe && pruductItem?.skus?.length > 1) {
            onSpecClick(item);
        }
    };

    const renderPriceContent = () => {
        // salePrice不等于活动价，则肯定是券后价
        if (currentSku.salePrice > 0 && currentSku.salePrice < currentSku.activityPrice) {
            return (
                <Flex style={{"flex":1,"marginRight":"1.9323671497584543rem"}} className={'price'} flex={'flexCol'}>
                    <View>
                        <Text style={{"fontSize":"2.6570048309178746rem","lineHeight":"3.140096618357488rem","color":"#FF4906"}}>
                            {$k18n({ id: '1e202bd42f3b632dcf249fb70801e9e6', text: '券后价' })}
                        </Text>
                        <Text style={{"fontSize":"3.8647342995169085rem","lineHeight":"4.5893719806763285rem","color":"#FF4906","fontWeight":"500","marginTop":"0.48309178743961356rem"}}>
                            {currentSku?.displaySalePrice}
                        </Text>
                    </View>
                </Flex>
            );
        }
        return (
            <Flex style={{"flex":1,"marginRight":"1.9323671497584543rem"}} className={'price'} flex={'flexCol'}>
                <Text style={[styles.price, currentSku?.displaySkuMarketPrice ? styles.textRed : styles.textBlack]}>
                    {currentSku?.displaySalePrice}
                </Text>
                <KView style={{"display":"flex","flexDirection":"row","alignItems":"center"}}>
                    {currentSku?.skuMarketPrice ? (
                        <Text style={styles.underlinePrice}>{currentSku?.displaySkuMarketPrice}</Text>
                    ) : pruductItem?.activityInfo?.activityId ? (
                        <KText style={styles.underlinePrice} rtlClassName={'coudan-item-price-off'}>
                            {pruductItem?.itemPrice?.displayAmount}
                        </KText>
                    ) : null}
                    {pruductItem?.discountRate ? (
                        <KView
                            style={{"borderWidth":"0.24154589371980678rem","borderColor":"rgba(255, 0, 0, 0.12)","borderRadius":"0.7246376811594204rem","paddingLeft":"0.48309178743961356rem","paddingRight":"0.48309178743961356rem","marginLeft":"0.9661835748792271rem"}}>
                            <KText
                                style={{"color":"#FF4906","fontSize":"2.173913043478261rem","fontWeight":"500"}}>
                                {currentSku?.discountRate}% OFF
                            </KText>
                        </KView>
                    ) : null}
                </KView>
            </Flex>
        );
    };

    return (
        <Flex style={{ flex: 1, ...style }} flex={['flexRow']}>
            <KTouchableWithoutFeedback onPress={goDetail}>
                <View style={styles.imageBox}>
                    <KwaiImage style={styles.img} source={{ uri: skuImageUrl }} />
                    {/* {pruductItem.errorText ? (
                        <Flex
                            flex={'flexCenter'}
                            style={{"position":"absolute","top":"0rem","bottom":"0rem","left":"0rem","right":"0rem","backgroundColor":"rgba(0,0,0,0.6)"}}
                        >
                            <Text style={stylesFn({ textAlign: 'center', color: '#fff' })}>{pruductItem.errorText}</Text>
                        </Flex>
                    ) : null} */}
                    {Number(itemId) === Number(pruductItem?.itemId) ? (
                        <KView
                            style={{"textAlign":"center","position":"absolute","bottom":"3.8647342995169085rem","width":"100%","zIndex":20,"display":"flex","flexDirection":"row","justifyContent":"center"}}>
                            <KView
                                style={{"borderRadius":"0.9661835748792271rem","paddingLeft":"0.9661835748792271rem","paddingRight":"0.9661835748792271rem","paddingTop":"0.48309178743961356rem","paddingBottom":"0.48309178743961356rem","zIndex":20,"backgroundColor":"rgba(0, 0, 0, 0.4)"}}>
                                <KText
                                    style={{"color":"#fff","fontSize":"2.8985507246376816rem","fontWeight":"400"}}>
                                    {$k18n({ id: 'k_420453' })}
                                </KText>
                            </KView>
                        </KView>
                    ) : null}
                </View>
            </KTouchableWithoutFeedback>
            <Flex style={{"flex":1}} flex={['flexColBtw']}>
                <KTouchableWithoutFeedback onPress={goDetail}>
                    <View>
                        <Text numberOfLines={2} ellipsizeMode="tail" style={stylesFn({ color: '#000' })}>
                            {pruductItem?.title}
                        </Text>
                        {pruductItem.status === 2 ? null : (
                            <KTouchableWithoutFeedback onPress={() => clickSpecDesc(pruductItem)}>
                                <KView
                                    style={{"backgroundColor":"#f7f7f7","display":"flex","flexDirection":"row","marginTop":"1.4492753623188408rem","alignItems":"center","alignSelf":"flex-start","borderRadius":"0.7246376811594204rem"}}>
                                    <Text
                                        numberOfLines={1}
                                        ellipsizeMode="tail"
                                        style={stylesFn({
                                            color: 'rgba(0,0,0,0.4)',
                                            alignSelf: 'flex-start',
                                            paddingTop: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 6,
                                            paddingRight: 6,
                                            maxWidth: 212,
                                        })}>
                                        {currentSku?.skuSpecDesc}
                                    </Text>
                                    {pruductItem?.skus?.length > 1 && showDetailCoudan?.if_product_addon_spec_modifiabe ? (
                                        <KwaiImage
                                            source={ArrowIcon}
                                            style={{"width":"3.8647342995169085rem","height":"3.8647342995169085rem","transform":[{"rotate":"90deg"}],"marginLeft":"0.9661835748792271rem","position":"relative","top":"0.24154589371980678rem"}}
                                        />
                                    ) : null}
                                </KView>
                            </KTouchableWithoutFeedback>
                        )}
                    </View>
                </KTouchableWithoutFeedback>

                {[2, 4].indexOf(pruductItem.status) > -1 ? null : (
                    <Flex style={{"marginTop":"3.6231884057971016rem"}} className={'content-bottom'} flex={'flexBtw'}>
                        {renderPriceContent()}

                        <Stepper
                            fallbackWhenEmpty={true}
                            min={pruductItem.minPurchase ?? 1}
                            disableText={true}
                            max={pruductItem?.activityInfo?.skuPurchasableCount?.[currentSku.skuId] ?? currentSku.availableQuantity}
                            value={currentSku.skuQuantity}
                            // onChange={onSkuNumChange}
                            onPlus={num => onSkuNumChangeV2(num, 1)}
                            onMinus={num => onSkuNumChangeV2(num, 0)}
                            onOverLimit={type => {
                                if (type === 'minus') {
                                    Toast.show({
                                        text: $k18n({ text: '最少购买{x}件', id: 'k_251870', params: { x: pruductItem.minPurchase ?? 1 } }),
                                    });
                                } else {
                                    Toast.show({
                                        text: $k18n({
                                            text: '最多购买{num}件',
                                            params: {
                                                num:
                                                    pruductItem?.activityInfo?.skuPurchasableCount?.[currentSku.skuId] ??
                                                    currentSku.availableQuantity,
                                            },
                                        }),
                                    });
                                }
                            }}
                        />
                    </Flex>
                )}

                {flashSaleCountDownStr ? (
                    <Flex>
                        <Text style={styles.timeoutStr}>{flashSaleCountDownStr}</Text>
                    </Flex>
                ) : (
                    <></>
                )}
            </Flex>
        </Flex>
    );
};

export default ProductCard;
